import { TWO_PI, PI } from "../math/constants";
import type { OrbitalElements } from "../math/orbital_elements";
import { positionAtTrueAnomaly } from "../math/orbital_math";
import { Vector3d } from "../math/vector3d";

/**
 * Generates orbit visualization paths by sampling true anomaly values.
 */
export function generateOrbitPath(
  elements: OrbitalElements,
  numSamples: number = 128,
): Vector3d[] {
  // For elliptical orbits (e < 1), sample full 2*pi
  const closed = elements.eccentricity < 1.0;
  const count = closed ? numSamples + 1 : numSamples;
  const points: Vector3d[] = new Array(count);

  const maxNu = closed ? TWO_PI : PI * 0.95;
  const step = maxNu / numSamples;

  for (let i = 0; i < numSamples; i++) {
    const nu = i * step;
    points[i] = positionAtTrueAnomaly(elements, nu);
  }

  if (closed) {
    points[numSamples] = points[0]; // Close the loop
  }

  return points;
}
